import type { INotifications } from '@erp/native/interfaces';

export function createWebNotifications(): INotifications {
  return {
    async ensurePermission() {
      if (typeof Notification === 'undefined') return false;
      if (Notification.permission === 'granted') return true;
      if (Notification.permission === 'denied') return false;
      const res = await Notification.requestPermission();
      return res === 'granted';
    },
    async show(n) {
      if (typeof Notification === 'undefined') return;
      if (Notification.permission !== 'granted') return;
      // We do not include `data.deepLink` execution here — for the web
      // build we just open the deep-link URL on click.
      const notif = new Notification(n.title, { body: n.body });
      if (n.deepLink) {
        notif.onclick = () => {
          window.focus();
          window.location.href = n.deepLink!;
          notif.close();
        };
      }
    },
  };
}
